import { Buffer } from 'buffer';

export function base64ToObject<T = object>(string: string): T {
  const decodedString = Buffer.from(string, 'base64');

  return JSON.parse(decodedString.toString());
}
